import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DisplayPictureComponent} from './display-picture.component';
import {LazyLoadImageModule} from 'ng-lazyload-image';

@NgModule({
    declarations: [DisplayPictureComponent],
    imports: [
        CommonModule,
        LazyLoadImageModule
    ],
    exports: [DisplayPictureComponent]
})
export class DisplayPictureModule {
}
